import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from "react";
import ValOrDash from "../../../components/ValOrDash";
import { Spin } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import { CurrencyFormat } from "../../../components/FormattersTS";
import HelpLabel from "../../../components/HelpLabel";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons/faMoneyBill";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const DeliveryExpenses = ({ deliveryExpenses }) => {
    if (!deliveryExpenses) {
        return _jsx(_Fragment, { children: "\u2014" });
    }
    return (_jsxs("h2", { className: "widget-value", children: [_jsx(ValOrDash, { val: deliveryExpenses.distanceKm }), "\u00A0/\u00A0", deliveryExpenses.costPerKm
                ? _jsx(CurrencyFormat, { value: deliveryExpenses.costPerKm })
                : _jsx(_Fragment, { children: "\u2014" }), "\u00A0/\u00A0", deliveryExpenses.averageCostPerDelivery
                ? _jsx(CurrencyFormat, { value: deliveryExpenses.averageCostPerDelivery })
                : _jsx(_Fragment, { children: "\u2014" })] }));
};
const EmployeeCostPerDeliveryWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    const refresh = () => {
        loadDeliveryExpenses();
    };
    const loadDeliveryExpenses = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/employee-delivery-expenses/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            setStateData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-dk-blue", children: _jsx(FontAwesomeIcon, { icon: faMoneyBill }) }), _jsx(DeliveryExpenses, { deliveryExpenses: stateData?.plannedDeliveryExpenses }), _jsx("p", { children: _jsx(HelpLabel, { title: "Planned Km / Cost per Km / Per delivery", helpText: "The average cost of the deliveries performed by company drivers only (i.e. excludes marketplace). It is calculated by determining the total planned hours for all deliveries multiplyed by the delivery hourly rate.  This value is an average of all deliveries. The Km rate is determined using the google maps travel time of each delivery." }) }), _jsx("div", { className: "widget-separator" }), _jsx(DeliveryExpenses, { deliveryExpenses: stateData?.completedDeliveryExpenses }), _jsx("p", { children: _jsx(HelpLabel, { title: "Completed Km / Cost per Km / Per delivery", helpText: _jsx("p", { children: "The cost for deliveries that have been completed. The cost per Km is calculated by dividing the cost by the total number of Km's the driver was estimated to travel using google maps (It is not the actual number of km's travelled)." }) }) })] }) }));
};
export default React.forwardRef(EmployeeCostPerDeliveryWidget);
